<template>
  <div class="pd-skeleton">
    <!-- Header Skeleton -->
    <div class="pd-sk-card pd-sk-header" style="margin-bottom: 24px; padding: 16px 20px;">
      <div style="display: flex; justify-content: space-between; align-items: center;">
         <div>
            <div class="pd-sk-line" style="width: 180px; height: 18px; margin-bottom: 8px;"></div>
            <div class="pd-sk-line" style="width: 300px; height: 12px;"></div>
         </div>
         <div class="pd-sk-line" style="width: 320px; height: 40px; border-radius: 8px;"></div>
      </div>
    </div>

    <!-- KPIs Skeleton -->
    <div class="pds__kpis pd-sk-row">
      <div class="pd-sk-card" v-for="i in 5" :key="i" style="height: 104px; padding: 14px;">
         <div class="pd-sk-line" style="width: 60%; height: 12px; margin-bottom: 16px;"></div>
         <div class="pd-sk-line" style="width: 40%; height: 24px; margin-bottom: 8px;"></div>
         <div class="pd-sk-line" style="width: 30%; height: 10px;"></div>
      </div>
    </div>

    <!-- Charts Skeleton -->
    <div class="pds__charts-row pd-sk-row" style="margin-top: 24px;">
      <div class="pd-sk-card" v-for="i in 4" :key="i" style="height: 280px; display: flex; flex-direction: column; padding: 18px;">
         <div class="pd-sk-line" style="width: 50%; height: 14px; margin-bottom: 8px;"></div>
         <div class="pd-sk-line" style="width: 30%; height: 10px; margin-bottom: 20px;"></div>
         <div class="pd-sk-block" style="flex: 1; border-radius: 8px;"></div>
      </div>
    </div>

    <!-- Table Skeleton -->
    <div class="pd-sk-card" style="margin-top: 24px; height: 350px; display: flex; flex-direction: column; padding: 0; overflow: hidden;">
       <div style="display: flex; justify-content: space-between; align-items: center; padding: 14px 20px; background: #F8FAFC; border-bottom: 1px solid #E2E8F0;" class="pd-sk-table-head">
          <div>
            <div class="pd-sk-line" style="width: 200px; height: 14px; margin-bottom: 8px;"></div>
            <div class="pd-sk-line" style="width: 150px; height: 10px;"></div>
          </div>
          <div class="pd-sk-line" style="width: 250px; height: 32px; border-radius: 8px;"></div>
       </div>
       <div class="pd-sk-line pd-sk-th" style="width: 100%; height: 36px; border-radius: 0; margin-bottom: 1px; background: #F1F5F9;"></div>
       <div class="pd-sk-line pd-sk-td" style="width: 100%; height: 44px; border-radius: 0; margin-bottom: 1px; background: #fff;" v-for="j in 5" :key="'t'+j"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardSkeleton'
}
</script>

<style scoped>
.pd-skeleton {
  width: 100%;
  animation: pd-sk-pulse 1.5s infinite ease-in-out;
}

.pd-sk-row {
  display: grid;
  gap: 12px;
}
.pds__kpis { grid-template-columns: repeat(5, 1fr); }
.pds__charts-row { grid-template-columns: repeat(4, 1fr); gap: 16px; }

@media(max-width:1400px){ .pds__charts-row{ grid-template-columns: repeat(2,1fr); } }
@media(max-width:1200px){ .pds__kpis{ grid-template-columns: repeat(3,1fr); } }
@media(max-width:768px) { 
  .pds__kpis{ grid-template-columns: repeat(2,1fr); }
  .pds__charts-row{ grid-template-columns: 1fr; }
}

.pd-sk-card {
  background: #fff;
  border: 1px solid #F1F5F9;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}

.pd-sk-line {
  background: #E2E8F0;
  border-radius: 4px;
}

.pd-sk-block {
  background: #F1F5F9;
}

@keyframes pd-sk-pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>

<style>
/* DARK MODE OVERRIDES */
#packaging-dashboard.pd--dark .pd-sk-card { 
  background: #1E293B !important; 
  border-color: #334155 !important; 
}
#packaging-dashboard.pd--dark .pd-sk-line { 
  background: #334155 !important; 
}
#packaging-dashboard.pd--dark .pd-sk-block { 
  background: #0F172A !important; 
}
#packaging-dashboard.pd--dark .pd-sk-table-head {
  background: #263548 !important;
  border-bottom-color: #334155 !important;
}
#packaging-dashboard.pd--dark .pd-sk-th {
  background: rgba(0,0,0,0.2) !important;
}
#packaging-dashboard.pd--dark .pd-sk-td {
  background: #1E293B !important;
  border-bottom: 1px solid #334155 !important;
}
</style>
